__turbopack_context__.v({
  "borderBottom": "pageTitle-module__rKO0ga__borderBottom",
  "borderTop": "pageTitle-module__rKO0ga__borderTop",
  "headerContainer": "pageTitle-module__rKO0ga__headerContainer",
  "headerInner": "pageTitle-module__rKO0ga__headerInner",
  "menuButton": "pageTitle-module__rKO0ga__menuButton",
  "menuWrapper": "pageTitle-module__rKO0ga__menuWrapper",
});
